import React, { useState } from 'react';
import { X } from 'lucide-react';
import { ClaimListingModal } from './ClaimListingModal';

export const AuctionModal = ({ isOpen, onClose, auction }) => {
  const [showClaimModal, setShowClaimModal] = useState(false);
  
  if (!isOpen || !auction) return null;

  const handleClaimClick = () => {
    setShowClaimModal(true);
  };

  return (
    <>
      <div className="fixed inset-0 z-50 overflow-y-auto" data-testid="auction-modal">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"
          onClick={onClose}
        ></div>

        {/* Modal Content */}
        <div className="flex min-h-screen items-center justify-center p-4">
          <div className="relative bg-white rounded-lg shadow-xl w-full max-w-6xl h-[85vh] flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-blue-900 text-white rounded-t-lg">
              <div className="flex-1">
                <h3 className="text-xl font-bold" data-testid="modal-auction-name">
                  {auction.name}
                </h3>
                <p className="text-sm text-blue-200">
                  {auction.location.city}, {auction.location.state}
                </p>
              </div>
              <div className="flex items-center space-x-2">
                {!auction.claimed && (
                  <button
                    onClick={handleClaimClick}
                    className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition text-sm"
                  >
                    🏆 Claim This Listing
                  </button>
                )}
                <button
                  onClick={onClose}
                  data-testid="modal-close-btn"
                  className="p-2 hover:bg-blue-800 rounded-full transition-colors"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

          {/* Iframe Container */}
          <div className="flex-1 overflow-hidden">
            <iframe
              src={auction.url}
              title={auction.name}
              className="w-full h-full"
              sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            />
          </div>

          {/* Footer */}
          <div className="p-4 border-t border-gray-200 bg-gray-50 rounded-b-lg">
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-600">
                <p><strong>Phone:</strong> {auction.phone || 'N/A'}</p>
                <p><strong>Email:</strong> {auction.email || 'N/A'}</p>
              </div>
              <a
                href={auction.url}
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-2 bg-blue-900 hover:bg-blue-800 text-white font-semibold rounded-lg transition-colors"
              >
                Visit Website Directly
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Claim Listing Modal */}
    <ClaimListingModal
      auction={auction}
      isOpen={showClaimModal}
      onClose={() => setShowClaimModal(false)}
    />
  </>
  );
};
